import { ProductMainInfo, ProjectItem, Project } from '@/types/supplier-search'

export const ProductInfoToPosition = (productMainInfo: ProductMainInfo, position: ProjectItem) => {
    position.Price = position.WithoutPrice ? null : position.Price;
    position.ProductId = productMainInfo.ProductId;
    position.TaxPercent = productMainInfo.TaxPercent;
	position.Okved2 = productMainInfo.Okved2Code;
	position.Okved2Name = productMainInfo.Okved2;
	position.Okpd2Name = productMainInfo.Okpd2;
	position.Okpd2 = productMainInfo.Okpd2Code;
    position.UnitCode = position.UnitCode ? position.UnitCode : productMainInfo.UnitCode;
    position.UnitName = position.UnitCode ? position.UnitName : productMainInfo.UnitName;
    position.UnitShortName = position.UnitCode ? position.UnitShortName : productMainInfo.UnitShortName;
    productMainInfo.Quantity = position.Amount;
}

export const PrepeareProjectsInfo = (projectsInfo: Project[]) => {
    projectsInfo.forEach((item) => {
        item.ApplicationEndDateInner = new Date(item.ApplicationEndDateInner + 'Z');
        item.Items.forEach((item) =>
            item.Characteristics.forEach((characteristic, index) => {
                characteristic.Index = index
                characteristic.NameFocused = false;
                characteristic.ShowTypeSelector = false;
                characteristic.TypeSelectorFocused = false;
            })
        )
    })
}

/**
 * Копирование (по ссылке!) входящих данных товара в основные сущности
 * @param state Состояние
 * @param productMainInfo Входящие данные товара
 */
export const SetMainProductinfo = (state: RootStateSupplierSearch, productMainInfo: ProductMainInfo) => {

    productMainInfo.Quantity = !productMainInfo.Quantity ? 1 : productMainInfo.Quantity;

    if (productMainInfo.SearchKeyword instanceof Array) {
        productMainInfo.SearchKeyword = productMainInfo.SearchKeyword.join(" ");
    }

    state.currentPosition.UnitCode = productMainInfo.UnitCode || '';
    state.currentPosition.UnitName = productMainInfo.UnitName || '';
    state.currentPosition.UnitShortName = productMainInfo.UnitShortName || '';
    state.currentPosition.Name = productMainInfo.SearchKeyword || productMainInfo.ProductName || '';
    state.currentProject.Name = productMainInfo.SearchKeyword || productMainInfo.ProductName || '';
    state.currentPosition.Amount = productMainInfo.Quantity;
    state.currentPosition.Okved2 = productMainInfo.Okved2Code;
    state.currentPosition.Okpd2 = productMainInfo.Okpd2Code;
    state.currentPosition.Okved2Name = productMainInfo.Okved2;
    state.currentPosition.Okpd2Name = productMainInfo.Okpd2;
}